module.exports = __webpack_public_path__ + "img/socinal_logo.52631350.png";